import React from 'react';

const MenuUniformesCancelarEntrega = ({link}) => {

    return (
        <></>
    );
}

export default MenuUniformesCancelarEntrega;